var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultVictim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60.0 60.0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1680,0 L1680,1080 L0,1080 L0,0 L1680,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.992,0 L15.0792071,0.00658161866 C15.3021975,0.0413580247 15.446,0.211333333 15.446,0.454 L15.446,3.68 L15.7381249,3.69511985 C21.4647381,4.06630278 26.0807833,8.77466667 26.304,14.537 L29.529,14.537 L29.6165048,14.5436159 C29.8401975,14.5785679 29.984,14.7493333 29.984,14.992 L29.9773841,15.0794705 C29.9424321,15.3029877 29.7716667,15.446 29.529,15.446 L26.304,15.446 L26.2888801,15.7381249 C25.9176969,21.4647381 21.2093167,26.0807833 15.446,26.304 L15.446,29.53 L15.4394184,29.6172071 C15.404642,29.8401975 15.2346667,29.984 14.992,29.984 L14.9047929,29.9773855 C14.6818025,29.9424444 14.538,29.7717778 14.538,29.53 L14.538,26.304 L14.2458751,26.2888801 C8.51926194,25.9176969 3.90321667,21.2093167 3.68,15.446 L0.455,15.446 L0.367495199,15.4394184 C0.143802469,15.404642 0,15.2346667 0,14.992 L0.00661591221,14.9044952 C0.0415679012,14.6808025 0.212333333,14.537 0.455,14.537 L3.679,14.537 L3.69416902,14.2449235 C4.06630306,8.51922917 8.77468333,3.90223333 14.538,3.68 L14.538,0.454 C14.538,0.181 14.719,0 14.992,0 Z M15.7281657,25.3792016 C20.9587313,25.0137091 25.171193,20.7129298 25.35,15.445 L25.395,14.538 L25.39,14.543 L24.305,15.727 L22.475,17.724 L21.007,19.326 L15.447,25.395 Z M14.537,4.588 L14.2558343,4.60374762 C9.02526839,4.96832533 4.81278947,9.27005263 4.633,14.537 L4.588,15.446 L4.60374853,15.7272174 C4.9683598,20.9587313 9.27103509,25.171193 14.537,25.35 L15.446,25.395 L21.007,19.326 L22.475,17.724 L24.305,15.727 L25.39,14.543 L25.3792524,14.2558334 C25.0146747,9.02523423 20.7129474,4.81182456 15.446,4.634 L14.538,4.589 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.984,0 L31.984,31.984 L0,31.984 L0,0 L31.984,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1515.0 -495.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1530.0 510.0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#i1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.0000000000001137 -1.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1,1 30.984,1 30.984,30.984 1,30.984 1,1",
    stroke: "none",
    fill: "#2795E3"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.29599999999994 10.16179999999986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.616,4.808 C9.616,2.153 7.463,0 4.808,0 C2.153,0 0,2.153 0,4.808 C0,7.463 2.153,9.616 4.808,9.616 C7.463,9.616 9.616,7.463 9.616,4.808 Z",
    stroke: "#2795E3",
    strokeWidth: 1,
    fill: "none",
    strokeMiterlimit: 10
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultVictim);
export default __webpack_public_path__ + "static/media/default-victim.770edeb8b82a5fdaee48f17979752626.svg";
export { ForwardRef as ReactComponent };